module.exports = {
  bindings: {
    item: '=ogFor',
    publicId: '<'
  },
  controller: require('./quantity-control.controller').name,
  template: '<div ng-include="$ctrl.templateUrl">/div>'
};
